import React from 'react'
import { Row, Col } from 'antd';
import { IATA_Certificate_2025, iso, iso_iec } from '../../utils/ImagePath';
// import { Helmet } from 'react-helmet';

function Certificates() {
    return (
        <>

            <section className='informationBanner'>
                <div className='container'>
                    <Row gutter={16} align="middle">
                        <Col md={16} sm={24}>
                            <div className='Package-cntr'>
                                <h2>Certificates</h2>
                            </div>
                        </Col>
                    </Row>
                </div>
            </section>

            <section className='ptb-50 container'>
                <Row gutter={20}>
                    <Col md={16} xs={24} className='mb-5'>
                        <img src={IATA_Certificate_2025} alt='IATA Certificate 2025' className='img-fluid' />
                    </Col>
                    <Col md={8} xs={24} className='mb-5'>
                        <img src="https://d1dejdv71ksru4.cloudfront.net/media/holiday/original/TamilNadu-Certificate.avif" alt='IATA Certificate 2025' className='img-fluid' />
                    </Col>
                    <Col md={12} xs={24}>
                        <img src={iso} alt='iso 9001-2015' className='img-fluid' />
                    </Col>
                    <Col md={12} xs={24}>
                        <img src={iso_iec} alt='iso-iec 27001-2022' className='img-fluid' />
                    </Col>
                </Row>
            </section>

        </>
    )
}

export default Certificates